import React from 'react';
import './PotentialManager.less';
import UserAvatar from '@components/UserAvatar';
import { MemberUserDto } from '@api/Api';
import { CrossIcon } from '@icons';

type PotentialManagerProps = {
  userData: MemberUserDto;
};

export default function PotentialManager({ userData }: PotentialManagerProps) {
  return (
    <div className="potential-manager">
      <div className="potential-manager--user">
        <UserAvatar
          isActive
          size="large"
          src={userData.picture.url || ''}
          userEmail={userData.email || ''}
          userName={userData.name || ''}
        />
        <div className="potential-manager--name">
          <span>{userData?.name}</span>
          <span>{userData?.email}</span>
        </div>
      </div>
      <CrossIcon className="close-icon" />
    </div>
  );
}
